<template>
    <div>
        <div class="regel" style="min-height: 20px;">
            <span class="marginright5 floatleft bold"
                >Hut {{ index + 1 }}:</span
            >
            <span v-if="cabinDetails" class="floatleft">
                {{ cabinDetails.naam }} {{ cabinDetails.code }}
            </span>
        </div>

        <div class="regel" style="min-height: 20px;">
            <span class="marginright5 floatleft bold">Actie:</span>
            <span
                v-if="rate && cabinDetails.isCampagne === rate.rateCode"
                class="floatleft"
                style="width: 180px"
            >
                <span v-html="cabinDetails.campagneTitle"></span> ({{
                    rateName(rate.rateCode)
                }})
            </span>
            <span v-else-if="rate" class="floatleft">
                {{ rateName(rate.rateCode) }}
            </span>
        </div>
        <div class="clearfix"></div>

        <div id="reizigers">
            <div
                v-for="index in cabinSetup.volwassenen"
                :key="'CabinSetupVolwassenen' + index"
                v-if="index > 0"
                class="persoon"
            >
                <span class="width58 floatleft">
                    Volwassene
                </span>
                <span v-if="rate" class="variabel width38 textright floatright">
                    €
                    {{
                        cabinSetup.volwassenen === 1
                            ? rate.prijs * 2
                            : rate.prijs
                    }},-
                </span>
            </div>
            <div
                v-for="index in cabinSetup.jeugd"
                :key="'CabinSetupJeugd' + index"
                v-if="index > 0"
                class="persoon"
            >
                <span class="width58 floatleft">
                    Jeugd
                </span>
                <span v-if="rate" class="variabel width38 textright floatright">
                    € {{ rate.prijs }},-
                </span>
            </div>
            <div
                v-for="index in cabinSetup.kinderen"
                :key="'CabinSetupKinderen' + index"
                v-if="index > 0"
                class="persoon"
            >
                <span class="width58 floatleft">
                    Kind
                </span>
                <span v-if="rate" class="variabel width38 textright floatright">
                    € {{ rate.prijs }},-
                </span>
            </div>
            <div
                v-for="index in cabinSetup.baby"
                :key="'CabinSetupBaby' + index"
                v-if="index > 0"
                class="persoon"
            >
                <span class="width58 floatleft">
                    Baby
                </span>
                <span v-if="rate" class="variabel width38 textright floatright">
                    € {{ rate.prijs }},-
                </span>
            </div>
        </div>

        <div class="clear height10"></div>
    </div>
</template>

<script>
export default {
    name: 'sidebarCabin',
    props: {
        index: Number,
    },
    methods: {
        rateName: function(rateCode) {
            return this.$store.getters.rateName(rateCode)
        },
    },
    computed: {
        rate: function() {
            return this.flattenedRates[this.cabinSetup.rateSelectIndex]
        },

        flattenedRates: function() {
            return this.$store.getters.flattenedRates
        },

        cabinDetails: function() {
            if (this.rate) {
                return this.$store.getters.cabinDetail(this.rate.cabinCode)
            }
            return null
        },
        cabinSetup: function() {
            return this.$store.state.cabinSetup[this.index]
        },
    },
}
</script>

<style scoped></style>
